export const manageArrowKeysDropdown = (keyCode, containerSelector, identifier) => {
  const optionsContainer = document.querySelector(containerSelector)
  if (!optionsContainer) return
  const selectedOption = optionsContainer.querySelector('.' + identifier)

  const updateOption = (element) => {
    if (element) {
      selectedOption.classList.remove(identifier)
      element.classList.add(identifier)
      element.scrollIntoView()
    }
  }

  if (keyCode === 40) {
    if (selectedOption) {
      const nextSibling = selectedOption.nextElementSibling
      updateOption(nextSibling)
    } else if (optionsContainer.firstChild) {
      optionsContainer.firstChild.classList.add(identifier)
    }
  }
  if (keyCode === 38) {
    if (selectedOption) {
      const previousSibling = selectedOption.previousElementSibling
      updateOption(previousSibling)
    }
  }
}
